const CONNECTION_INIT = 'CONNECTION_INIT';
const CONNECTION_SUCCESS = 'CONNECTION_SUCCESS';
const CONNECTION_FAIL = 'CONNECTION_FAIL';
const CHAT_MESSAGE_RECEIVED = 'CHAT_MESSAGE_RECEIVED';
const CHAT_MESSAGE_SENT = 'CHAT_MESSAGE_SENT';

const MOVE_RECEIVED = 'MOVE_RECEIVED';
const MOVE_SENT = 'MOVE_SENT';

const ENEMY_POKEMON_RECEIVED = 'ENEMY_POKEMON_RECEIVED';
const CLIENT_POKEMON_CHOSEN = 'CLIENT_POKEMON_CHOSEN';

const PLAYER_ROOM_JOIN = 'PLAYER_ROOM_JOIN';
const PLAYER_ROOM_LEFT = 'PLAYER_ROOM_LEFT';

const END_FIGHT = 'END_FIGHT';
const DROP_CONNECTION = 'DROP_CONNECTION';


const types = {
    CONNECTION_INIT,
    CONNECTION_SUCCESS,
    CONNECTION_FAIL,
    CHAT_MESSAGE_RECEIVED,
    CHAT_MESSAGE_SENT,

    MOVE_RECEIVED,
    MOVE_SENT,

    ENEMY_POKEMON_RECEIVED,
    CLIENT_POKEMON_CHOSEN,
    
    PLAYER_ROOM_JOIN,
    PLAYER_ROOM_LEFT,
    
    END_FIGHT,
    DROP_CONNECTION,
}

export default types;